export default __webpack_public_path__ + "static/media/empresa2.af1032fa.jpg";